<template>
  <div>
    <TopHeader code="topic" />

    <section class="uc-topicBanner"></section>

    <section class="container-fluid uc-bg uc-pt40 uc-pb40">
      <div class="container">
        <div class="row">
          <div class="col-24 col-sm-24">
            <section class="g-filterSearch uc-ml10 uc-pr10">
              <!-- <div
                v-for="(item, index) in tabList"
                :key="index"
                class="item"
                :class="item.status == query.status ? 'on' : ''"
                @click="
                  query.status = item.status;
                  loadData();
                "
              >
                {{ item.name }}
              </div> -->
              <el-select
                placeholder="话题分类"
                v-model="query.classId"
                @change="loadData"
              >
                <el-option :key="0" :value="0" label="所有话题分类" />
                <el-option
                  v-for="item in classList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.class_name"
                />
              </el-select>
              <el-checkbox
                v-model="isMy"
                @change="loadData"
                style="margin-left:1rem;"
              >
                我参与的
              </el-checkbox>
              <!-- <el-checkbox v-model="query.isElite" @change="loadData">
                精华
              </el-checkbox> -->
              <div class="search">
                <input
                  type="text"
                  placeholder="请输入您想查询的话题"
                  class="uc-input"
                  v-model="query.keyword"
                  @keyup.enter="loadData"
                />
                <input
                  type="submit"
                  value="搜索"
                  class="uc-btn blue"
                  @click="loadData"
                />
              </div>
            </section>
            <section
              class="g-filterSearch"
              style="display:flex; justify-content:center;"
            >
              <div
                v-for="(item, index) in tabList"
                :key="index"
                class="item"
                :class="item.status == query.status ? 'on' : ''"
                @click="
                  query.status = item.status;
                  loadData();
                "
              >
                {{ item.name }}
              </div>
            </section>
            <section class="container uc-encyclopediasList uc-topicList">
              <div class="content-empty" v-if="list.total_count == 0">
                <div class="emptyimg-box"></div>
                <p>暂无相关内容</p>
              </div>
              <div class="row">
                <div
                  v-for="(item, index) in list.items"
                  :key="index"
                  class="col-6 box"
                >
                  <router-link
                    :to="{
                      name: 'TopicDetails',
                      params: { id: item.id },
                    }"
                    class="item"
                    :style="
                      `background:url(${item.cover}); background-size:cover;`
                    "
                  >
                    <h3>{{ item.title }}</h3>
                    <div class="txt"></div>
                    <div class="btm">
                      <div class="left">
                        <div class="avatar-list">
                          <img
                            v-for="(item2, index2) in item.top5_answer_user"
                            :key="index2"
                            :src="item2.avatar"
                            :alt="item2.first_name"
                            :style="index2 == 0 ? 'margin-left:0;' : ''"
                            onerror="this.src=document.getElementById('avatar').src;this.onerror=null;"
                          />
                        </div>
                        {{ item.topic_answer_count }}人参与讨论
                        <!-- <img
                          class="icon-ding"
                          src="../../assets/images/ding.png"
                          v-if="item.is_top"
                        />
                        <img
                          class="icon-ding"
                          src="../../assets/images/jing.png"
                          v-if="item.is_elite"
                        /> -->
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
            </section>

            <el-pagination
              class="uc-prvNxt"
              background
              layout="prev, pager, next"
              hide-on-single-page
              :current-page="query.pageIndex"
              :page-size="query.pageSize"
              :total="list.total_count"
              @current-change="handleCurrentChange"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </section>

    <BottomFooter />
  </div>
</template>

<script>
import TopHeader from '@/components/TopHeader.vue';
import BottomFooter from '@/components/BottomFooter.vue';

export default {
  name: 'Topic',
  components: {
    TopHeader,
    BottomFooter,
  },
  data() {
    return {
      isMy: false,
      tagSel: 0,
      tabList: [
        { name: '最新', status: 0 },
        { name: '最热', status: 1 },
      ],
      query: {
        tagId: undefined,
        status: 0,
        pageIndex: 1,
        pageSize: 12,
        keyword: undefined,
        classId: 0,
        isElite: false,
      },
      list: {},
      tagList: {},
      classList: {},
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.loadData();
      this.getTags();
      this.getTopicClassList();
    },
    loadData() {
      if (this.isMy) {
        this.getMyTopics();
      } else {
        this.getTopics();
      }
    },
    async getTags() {
      const response = await this.$api.tag.getTags();
      this.tagList = response.data.data;
    },
    async getTopics() {
      const response = await this.$api.topic.getTopics(this.query);
      this.list = response.data.data;
    },
    getTopicClassList() {
      this.$api.topic
        .getTopicClassList(null)
        .then((response) => {
          this.classList = response.data.data.content;
          // console.log('classList', response.data.data.content)
        })
        .catch((error) => console.log(error));
    },
    async getMyTopics() {
      const response = await this.$api.topic.getMyTopics(this.query);
      this.list = response.data.data;
    },
    // 翻页
    handleCurrentChange(val) {
      this.query.pageIndex = val;
      this.loadData();
    },
    // 切换标签
    handleTagClick(tagId) {
      this.query.tagId = tagId;
      this.loadData();
    },
  },
};
</script>
